import React from 'react';
import PropTypes from 'prop-types';
import styles from './CartSummary.scss';
import { formatPriceFromLocaleInfo } from '../../common/helpers/currencyHelpers';

export function CartSummary(props) {
  const { subtotal, site, t } = props;

  const { localeInfo } = site;

  return (
    <div className={styles.container}>
      <div className={styles.label}>{t('Wix_Provider_UOU_Checkout_Cart_Subtotal_Label')}</div>
      <div className={styles.price}> {formatPriceFromLocaleInfo(subtotal, localeInfo)} </div>
    </div>
  );
}

CartSummary.propTypes = {
  subtotal: PropTypes.any,
  site: PropTypes.any,
  t: PropTypes.func
};
